module.exports = __webpack_public_path__ + "static/media/thumbnail-robotBack.166dbba1.png";